
<!-- 个人中心 -->
<template>
  <div class="person">
    <cancelDialog
      v-if="isShowDialog"
      @logout="cancel"
      @close="isShowDialog = false"
    ></cancelDialog>
    <div class="logo">
      <img
        src="../assets/images/title1.png"
        alt=""
        @click="$emit('go-master')"
      />
      <span>|个人中心</span>
    </div>
    <span v-if="isIdentify" class="cancel" @click="cancelAccount"
      >【慎点】申请注销账号</span
    >
    <div class="profile-container">
      <div class="profile-info">
        <h2>我的信息</h2>
        <p>用户名: {{ username }}</p>
        <div style="display: flex; align-items: center; height: 50px">
          <p>手机: {{ userphone }}</p>
          <button class="had-check">已验证</button>
        </div>
        <div style="display: flex; align-items: center; height: 50px">
          <p>身份证:</p>
          <button @click="goCheck" v-if="!isIdentify" class="start-check">
            开始实名认证
          </button>
          <div v-else style="display: flex; align-items: center">
            <p style="white-space: nowrap">尾号后四位 {{ card }}</p>
            <button class="had-check">已实名</button>
          </div>
        </div>
        <!-- <button class="logout-button" @click="$emit('show-dialog')">
          退出
        </button> -->
      </div>
      <div class="order-list">
        <h2>订单列表</h2>
        <ul v-if="orderList.length">
          <li v-for="(order, index) in orderList" :key="index">
            订单号：{{ order.id }} 时间：{{ formatTime(order.time) }}:{{
              username
            }}购买了商品: {{ order.skuName }}
          </li>
        </ul>
        <span v-else>当前暂无订单</span>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../servies/api";
import { EventBus } from "@/eventBus"; // 导入全局事件总线
import cancelDialog from "./cancel-dialog.vue";
export default {
  components: {
    cancelDialog
  },
  data() {
    return {
      isShowDialog: false,
      card: "",
      isIdentify: false, // 是否已经实名认证
      userphone: "",
      username: "",
      orderList: [],
      orders: [
        { id: 1, name: "订单1", details: "订单详情示例" },
        { id: 2, name: "订单2", details: "订单详情示例" },
        { id: 3, name: "订单3", details: "订单详情示例" },
        { id: 1, name: "订单1", details: "订单详情示例" },
        { id: 2, name: "订单2", details: "订单详情示例" },
        { id: 3, name: "订单3", details: "订单详情示例" },
        { id: 1, name: "订单1", details: "订单详情示例" },
        { id: 2, name: "订单2", details: "订单详情示例" },
        { id: 3, name: "订单3", details: "订单详情示例" },
      ],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    cancel() {
      api.cancelAccount({}).then((res) => {
        if (res.code !== 0) {
          return;
        }
        alert("注销成功");
        this.isShowDialog = false;

        EventBus.$emit("cancel");
        localStorage.setItem("isIdentify", false);
        // 回退一个页面
        this.$router.replace("series");
      });
    },

    cancelAccount() {
      this.isShowDialog = true;
    },
    goCheck() {
      this.$router.push("/identify");
    },
    getData() {
      api.getUserInfo({}).then((res) => {
        if (res.code !== 0) {
          if (res.code === 1025||res.code === 5) {
            this.$router.replace("login");
          }
          return;
        }
        this.userphone = res.resultData.user.phone;
        this.username = res.resultData.user.name;
        this.orderList = res.resultData.orderList;
        // 去掉res.resultData.user.idNo空格后的判断长度
        // res.resultData.user.idNo字符串去掉空格

        this.isIdentify = res.resultData.user.idNo.length > 0;
        //截取后四位
        if (this.isIdentify) {
          this.card = res.resultData.user.idNo.slice(-4);
        }

        console.log("getUserInfo", this.orderList);
      });
    },
    // 格式化时间戳
    formatTime(time) {
      const date = new Date(time);
      return `${date.getFullYear()}-${
        date.getMonth() + 1
      }-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
    },
  },
};
</script>
<style scoped lang='less'>
.person {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  padding: 100px 0 0 40px;
  .cancel {
    position: absolute;
    left: 560px;
    top: 150px;
    color: red;
    cursor: pointer;
  }
  .logo {
    position: absolute;
    left: 60px;
    z-index: 99;
    top: 130px;
    display: flex;
    align-items: center;
    img {
      width: 112px;
    }
    span {
      font-size: 25px;
      font-weight: bold;
      color: gray;
    }
  }
}
.profile-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 800px;
  margin: 100px 20px;
  padding: 20px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.had-check {
  // 浅绿色 已经验证标示按钮
  background-color: #28a745;
  // 字体颜色 适配背景色
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  max-width: 100px;
  margin-left: 10px;
  transition: background-color 0.3s ease;
}
.start-check {
  // 浅蓝色 开始验证按钮
  background-color: #007bff;
  // 字体颜色 适配背景色
  color: white;
  padding: 10px 10px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  max-width: 150px;
  margin-left: 10px;
  transition: background-color 0.3s ease;
}
.profile-info,
.order-list {
  width: 100%;
  margin-bottom: 20px;
  // 退出按钮
  .logout-button {
    padding: 10px 20px;
    background-color: #dc3545;
    border: none;
    border-radius: 6px;
    color: white;
    font-size: 14px;
    cursor: pointer;
    max-width: 100px;
    transition: background-color 0.3s ease;

    &:hover {
      background-color: #c82333;
    }
  }

  h2 {
    margin-bottom: 10px;
    color: #333;
    font-size: 24px;
    font-weight: 600;
  }

  p,
  li {
    color: #555;
    font-size: 16px;
    margin-bottom: 8px;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    padding: 10px;
    background: #f7f9fc;
    border-radius: 6px;
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/person.vue